module.exports = __webpack_public_path__ + "img/18_71.52daa966.png";